import React from 'react';

const ResumeThresholdSection: React.FC = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">简历不够门槛怎么办？</h2>
          <p className="text-xl text-gray-600">抢跑式岗位内推帮你提前把握高含金量机遇</p>
        </div>

        <div className="space-y-8">
          <div className="bg-gradient-to-br from-red-50 to-red-100 p-8 rounded-xl">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="lg:w-1/2">
                <img 
                  src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/79a4c1f8b7c09c1be87c95d35c929183.png"
                  alt="抢跑式内推"
                  className="w-full h-32 md:h-64 object-cover rounded-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h4 className="text-2xl font-bold text-gray-900 mb-3">岗位万人投 抢不过？</h4>
                <p className="text-lg text-red-600 font-semibold mb-4">抢跑式内推</p>
                <p className="text-gray-700 leading-relaxed">提前获得内部岗位信息，通过内推渠道避开激烈竞争，在岗位公开前就已直面招聘官，大幅提升录取概率。我们与2000+全球名企建立深度合作关系，为您提供独家内推机会。</p>
              </div>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-blue-50 to-blue-100 p-8 rounded-xl">
            <div className="flex flex-col lg:flex-row-reverse items-center gap-8">
              <div className="lg:w-1/2">
                <img 
                  src="https://static.readdy.ai/image/369c6d7d3639e005f7b761af84a5109d/0794f6dc906e45c82d08462aae79609d.png"
                  alt="高含金量实习"
                  className="w-full h-32 md:h-64 object-cover rounded-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h4 className="text-2xl font-bold text-gray-900 mb-3">第一份实习最难找？</h4>
                <p className="text-lg text-blue-600 font-semibold mb-4">直录高含金量实习岗位</p>
                <p className="text-gray-700 leading-relaxed">跳过层层筛选，直接获得知名企业实习机会。我们与顶级企业建立直通渠道，为您匹配最适合的实习岗位，为简历增添亮点，为未来求职奠定坚实基础。</p>
              </div>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-green-50 to-green-100 p-8 rounded-xl">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="lg:w-1/2">
                <img 
                  src="https://public.readdy.ai/ai/img_res/dec0c74e1af547ebe2143df387181708.jpg"
                  alt="真题练习"
                  className="w-full h-32 md:h-64 object-cover rounded-lg"
                />
              </div>
              <div className="lg:w-1/2">
                <h4 className="text-2xl font-bold text-gray-900 mb-3">笔试面试做不对？</h4>
                <p className="text-lg text-green-600 font-semibold mb-4">在考真题提前练</p>
                <p className="text-gray-700 leading-relaxed">获得最新真题资源，提前熟悉考试形式和内容。我们收集各大企业最新笔试面试真题，提供专业解析和模拟练习，大幅提升通过率，让您在考试中游刃有余。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ResumeThresholdSection;
